import { render, staticRenderFns } from "./CommunicationDetailModal.vue?vue&type=template&id=2a42d555&"
import script from "./CommunicationDetailModal.vue?vue&type=script&lang=js&"
export * from "./CommunicationDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports